const STATIC = window.location.port === '41654';

export default class ApiService {

	constructor($http) {
		this.http = $http;
		const api = {
			storeLocator: {
				all: (isStatic) => {
					if (STATIC || isStatic) {
						return $http.get('Modules/StoreLocator/docs/data/store-locator.json');
					} else {
						return $http.post('/ws/wsUsers.asmx/StoreList', {});
					}
				},
			},
			agentLocator: {
				all: () => {
					return $http.post('/ws/wsUsers.asmx/AgentList', {});
				}
			}
		};
		Object.assign(this, api);
	}

	static factory($http) {
		return new ApiService($http);
	}

}

ApiService.factory.$inject = ['$http'];
